import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'

import { Button, Page, Spinner, Title, ValidatedInput } from '../../../components'
import CountryPickerModal from '../../../containers/CountryPickerModal'
import countries from '../../../countries.json'
import { ICountry } from '../../../models/country'
import { isEmailValid, isTelephoneValid } from '../../../helpers'
import { LiteralsService } from '../../../services'
import {
  resendVerificationCodeAction,
  setVerificationCallingCodeAction,
  setVerificationCountryAction,
  setVerificationEmailAction,
  setVerificationPhoneAction
} from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from '../styles'
import { appsLogosSelected, appsStyleSelected, appsUsernameSelected } from '../../../helpers/app'
import { AnyAction } from 'redux'

const isPhoneVerification = appsUsernameSelected?.username === 'phone'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  dni: string
  email: string
  phone: string
  isSendingNewCode: boolean
  country?: ICountry
  callingCode: string
}

class AccountVerificationResend extends PureComponent<IProps> {
  constructor(props: IProps) {
    super(props)
    if (isPhoneVerification && !props.country) {
      const defaultCountry = countries.find(country => country.code === 'ES')
      if (defaultCountry) {
        props.dispatch(setVerificationCountryAction(defaultCountry))
        props.dispatch(setVerificationCallingCodeAction(defaultCountry.dial_code))
      }
    }
  }

  private get buttonIsDisabled(): boolean {
    const { email, phone, isSendingNewCode } = this.props

    if (isPhoneVerification) return !isTelephoneValid(phone) || isSendingNewCode
    return !isEmailValid(email) || isSendingNewCode
  }

  private get verificationButton(): ReactNode {
    const { isSendingNewCode } = this.props
    if (isSendingNewCode) return <Spinner />
    return (
      <Button
        title={ LiteralsService.get('continue') }
        onPress={ this.handleValidatedButtonPress }
        filled
        upper
        isDisabled={ this.buttonIsDisabled }
      />
    )
  }

  public render(): ReactNode {

    const { email, phone, country } = this.props

    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <form onSubmit={ e => e.preventDefault() }>
            <header>
              <img  className={ appsLogosSelected?.classRounded }
                    src={ appsLogosSelected?.logoRounded }
                    alt={ appsLogosSelected?.alt } />
            </header>
            <Title text={ LiteralsService.get('requestNewSignUpVerificationCode', true) }/>
            <section>
              {
                isPhoneVerification ? (
                  <ValidatedInput
                    name="phone"
                    phone
                    label={ LiteralsService.get('phone', true) }
                    value={ phone }
                    country={ country }
                    onChange={ this.onPhoneChange }
                    error={ !isTelephoneValid(phone) }
                  />
                ) : (
                  <ValidatedInput
                    name="email"
                    label={ LiteralsService.get('email', true) }
                    value={ email }
                    onChange={this.onEmailChange}
                    error={ !isEmailValid(email) }
                  />
                )
              }
            </section>
            { isPhoneVerification && <CountryPickerModal selectCountry={ this.onCountryChange } /> }
            <section className="actions">
              { this.verificationButton }
            </section>
          </form>
        </StyledArticle>
      </Page>
    )
  }

  private onEmailChange = (email: string) => {
    const { dispatch } = this.props
    dispatch(setVerificationEmailAction(email))
  }

  private onPhoneChange = (phone: string) => {
    const { dispatch } = this.props
    dispatch(setVerificationPhoneAction(phone))
  }

  private onCountryChange = (country: ICountry) => {
    const { dispatch } = this.props
    dispatch(setVerificationCountryAction(country))
    dispatch(setVerificationCallingCodeAction(country.dial_code))
  }

  private handleValidatedButtonPress = () => {
    const { dispatch } = this.props
    dispatch(resendVerificationCodeAction())
  }
}

const mapStateToProps = ({ verification, signUp }: IStoreState) => ({
  dni: signUp.dni,
  email: verification.email ? verification.email : signUp.email,
  phone: verification.phone ? verification.phone : signUp.phone,
  isSendingNewCode: verification.isSendingNewCode,
  country: verification.country,
  callingCode: verification.callingCode
})

export default withRouter(connectRedux(mapStateToProps, AccountVerificationResend))
